import type { PhotosResponse } from '@brimstone/shared';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { api } from './api';

export interface PhotoFilters {
  /** Character ids, or `unknown` for photos nobody's spot or session claims. */
  characterIds: string[];
  /** A week id ("2026-11-18"), or null for all weeks. */
  week: string | null;
}

function query(f: PhotoFilters, limit: number, cursor: string | null): string {
  const p = new URLSearchParams({ limit: String(limit) });
  if (f.characterIds.length) p.set('characterId', f.characterIds.join(','));
  if (f.week) p.set('week', f.week);
  if (cursor) p.set('cursor', cursor);
  return `/api/photos?${p.toString()}`;
}

const PAGE = 60;

/** Screenshots newest first, a page at a time (M12). */
export function usePhotos(f: PhotoFilters) {
  return useInfiniteQuery({
    queryKey: ['photos', f],
    queryFn: ({ pageParam }) => api<PhotosResponse>(query(f, PAGE, pageParam)),
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.nextCursor,
  });
}

/** The latest photos of one character or one week, for the Book and Digest pages. */
export function useLatestPhotos(f: PhotoFilters, limit: number) {
  return useQuery({
    queryKey: ['photos', 'latest', f, limit],
    queryFn: () => api<PhotosResponse>(query(f, limit, null)),
  });
}
